<app-dialog-header [title]="ticket ? 'Editar Ingresso' : 'Criar Novo Ingresso'"></app-dialog-header>

<mat-dialog-content>
  <div class="container modal-ticket" id="modalTicket">
    <form [formGroup]="ticketForm" (ngSubmit)="saveTicket()">
      <div class="ticket-form-layout">
        <div>
          <p class="h4">Informações do Ingresso</p>
          <p class="p text-secondary">
            Forneça um nome claro e uma descrição atrativa. Defina a quantidade disponível e o preço por ingresso
          </p>
          @if (showsHalfPricePair) {
            <p class="p text-secondary mt-2">
              O lote está com meia-entrada. Preencha a <strong>inteira</strong> e a <strong>meia-entrada</strong>: os
              dois ingressos são criados juntos, cada um com quantidade e valor próprios.
            </p>
          } @else if (ticket?.half_price) {
            <p class="p text-secondary mt-2">
              Este é o ingresso de <strong>meia-entrada</strong>. Valor e quantidade são independentes da inteira. Na
              venda, o cliente verá as regras (CIE, CIPTEA/autismo, PCD, idoso e CadÚnico).
            </p>
          }
        </div>

        <div class="row">
          <div class="col-12" [class.col-lg-4]="!showsHalfPricePair" [class.col-md-6]="!showsHalfPricePair">
            <label for="ticketTitle" class="form-label">Nome do Ingresso</label>
            <input
              id="ticketTitle"
              formControlName="ticketTitle"
              type="text"
              class="form-control"
              [class.is-invalid]="ticketForm.controls.ticketTitle.touched && ticketForm.controls.ticketTitle.invalid" />
            @if (ticketForm.controls.ticketTitle.touched && ticketForm.controls.ticketTitle.hasError("required")) {
              <div class="invalid-feedback">Nome do ingresso é obrigatório.</div>
            }
          </div>

          @if (!showsHalfPricePair) {
            <div class="col-sm-6 col-md-6 col-lg-4">
              <label for="quantity" class="form-label">Quantidade</label>
              <input
                id="quantity"
                formControlName="quantity"
                type="number"
                class="form-control"
                [class.is-invalid]="ticketForm.controls.quantity.touched && ticketForm.controls.quantity.invalid" />
              @if (ticketForm.controls.quantity.touched) {
                @if (ticketForm.controls.quantity.hasError("required")) {
                  <div class="invalid-feedback">Quantidade é obrigatória.</div>
                }
                @if (ticketForm.controls.quantity.hasError("min")) {
                  <div class="invalid-feedback">Quantidade deve ser maior que 0.</div>
                }
              }
            </div>

            <div class="col-sm-6 col-md-6 col-lg-4">
              <label for="price" class="form-label">Valor do ingresso</label>
              <input
                id="price"
                formControlName="price"
                type="number"
                class="form-control"
                [class.is-invalid]="ticketForm.controls.price.touched && ticketForm.controls.price.invalid"
                placeholder="GRÁTIS" />
              @if (ticketForm.controls.price.touched) {
                @if (ticketForm.controls.price.hasError("required")) {
                  <div class="invalid-feedback">O preço é obrigatório.</div>
                }
                @if (ticketForm.controls.price.hasError("minimumTicketPrice")) {
                  <div class="invalid-feedback">Informe zero para gratuito ou pelo menos R$ 1,00.</div>
                }
              }

              @if (!isTicketFree) {
                <div class="d-flex gap-2 mt-1" [title]="getTaxString()">
                  <span>Valor final</span>
                  <p class="p text-success">{{ getFinalPriceString() | currency: "BRL" }}</p>
                </div>
              }
            </div>
          }
        </div>

        @if (showsHalfPricePair) {
          <div class="ticket-price-pair">
            <div>
              <p class="h4 title">Ingresso inteira</p>
              <div class="row mt-2">
                <div class="col-sm-6">
                  <label for="quantity" class="form-label">Quantidade</label>
                  <input
                    id="quantity"
                    formControlName="quantity"
                    type="number"
                    class="form-control"
                    [class.is-invalid]="ticketForm.controls.quantity.touched && ticketForm.controls.quantity.invalid" />
                  @if (ticketForm.controls.quantity.touched) {
                    @if (ticketForm.controls.quantity.hasError("required")) {
                      <div class="invalid-feedback">Quantidade é obrigatória.</div>
                    }
                    @if (ticketForm.controls.quantity.hasError("min")) {
                      <div class="invalid-feedback">Quantidade deve ser maior que 0.</div>
                    }
                  }
                </div>
                <div class="col-sm-6">
                  <label for="price" class="form-label">Valor</label>
                  <input
                    id="price"
                    formControlName="price"
                    type="number"
                    class="form-control"
                    [class.is-invalid]="ticketForm.controls.price.touched && ticketForm.controls.price.invalid" />
                  @if (ticketForm.controls.price.touched) {
                    @if (ticketForm.controls.price.hasError("required")) {
                      <div class="invalid-feedback">O preço é obrigatório.</div>
                    }
                    @if (ticketForm.controls.price.hasError("minimumTicketPrice")) {
                      <div class="invalid-feedback">Informe zero para gratuito ou pelo menos R$ 1,00.</div>
                    }
                  }
                  <div class="d-flex gap-2 mt-1" [title]="getTaxString()">
                    <span>Valor final</span>
                    <p class="p text-success">{{ getFinalPriceString() | currency: "BRL" }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <p class="h4 title">Ingresso meia-entrada</p>
              <p class="p text-secondary mb-2">
                Quantidade e valor independentes. A sugestão inicial é 40% da quantidade e 50% do valor da inteira.
              </p>
              <div class="row">
                <div class="col-sm-6">
                  <label for="halfPriceQuantity" class="form-label">Quantidade</label>
                  <input
                    id="halfPriceQuantity"
                    formControlName="halfPriceQuantity"
                    type="number"
                    class="form-control"
                    [class.is-invalid]="
                      ticketForm.controls.halfPriceQuantity.touched && ticketForm.controls.halfPriceQuantity.invalid
                    " />
                  @if (ticketForm.controls.halfPriceQuantity.touched) {
                    @if (ticketForm.controls.halfPriceQuantity.hasError("required")) {
                      <div class="invalid-feedback">Quantidade é obrigatória.</div>
                    }
                    @if (ticketForm.controls.halfPriceQuantity.hasError("min")) {
                      <div class="invalid-feedback">Quantidade deve ser maior que 0.</div>
                    }
                  }
                </div>
                <div class="col-sm-6">
                  <label for="halfPricePrice" class="form-label">Valor</label>
                  <input
                    id="halfPricePrice"
                    formControlName="halfPricePrice"
                    type="number"
                    class="form-control"
                    [class.is-invalid]="
                      ticketForm.controls.halfPricePrice.touched && ticketForm.controls.halfPricePrice.invalid
                    " />
                  @if (ticketForm.controls.halfPricePrice.touched) {
                    @if (ticketForm.controls.halfPricePrice.hasError("required")) {
                      <div class="invalid-feedback">O preço é obrigatório.</div>
                    }
                    @if (ticketForm.controls.halfPricePrice.hasError("minimumTicketPrice")) {
                      <div class="invalid-feedback">Informe zero para gratuito ou pelo menos R$ 1,00.</div>
                    }
                  }
                  <div class="d-flex gap-2 mt-1" [title]="getTaxString('halfPricePrice')">
                    <span>Valor final</span>
                    <p class="p text-success">{{ getFinalPriceString("halfPricePrice") | currency: "BRL" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }


        <div class="ticket-details-grid">
          <div class="ticket-description">
            <label for="ticketDescription" class="form-label">Descrição do ingresso</label>
            <textarea
              pTextarea
              name="ticketDescription"
              id="ticketDescription"
              cols="20"
              rows="3"
              placeholder="Digite a descrição do ingresso"
              formControlName="ticketDescription"
              [class.is-invalid]="
                ticketForm.controls.ticketDescription.touched && ticketForm.controls.ticketDescription.invalid
              "></textarea>
            @if (
              ticketForm.controls.ticketDescription.touched &&
              ticketForm.controls.ticketDescription.hasError("required")
            ) {
              <div class="invalid-feedback">A descrição é obrigatória.</div>
            }
          </div>

          <div class="row ticket-purchase-limits">
            <div>
              <p class="h4 title">Quantidade permitida por compra</p>
              <p class="p text-secondary">Limite de ingressos por comprador.</p>
            </div>

            <div class="col">
              <label for="minTickets" class="form-label">Mínimo</label>
              <input
                id="minTickets"
                formControlName="minTickets"
                type="number"
                class="form-control"
                [class.is-invalid]="ticketForm.controls.minTickets.touched && ticketForm.controls.minTickets.invalid" />
              @if (ticketForm.controls.minTickets.touched) {
                @if (ticketForm.controls.minTickets.hasError("required")) {
                  <div class="invalid-feedback">Quantidade mínima é obrigatória.</div>
                }
                @if (ticketForm.controls.minTickets.hasError("min")) {
                  <div class="invalid-feedback">Quantidade mínima deve ser maior que 0.</div>
                }
              }
            </div>

            <div class="col">
              <label for="maxTickets" class="form-label">Máximo</label>
              <input
                id="maxTickets"
                formControlName="maxTickets"
                type="number"
                class="form-control"
                [min]="1"
                [max]="ticketForm.controls.quantity.value"
                [class.is-invalid]="
                  ticketForm.controls.maxTickets.touched &&
                  (ticketForm.controls.maxTickets.invalid ||
                    ticketForm.hasError('maxTicketsExceededQuantity') ||
                    ticketForm.hasError('maxTicketsLessThanMinTickets'))
                " />

              @if (ticketForm.controls.maxTickets.touched) {
                @if (ticketForm.controls.maxTickets.hasError("required")) {
                  <div class="invalid-feedback">Quantidade máxima é obrigatória.</div>
                }
                @if (ticketForm.controls.maxTickets.hasError("min")) {
                  <div class="invalid-feedback">Quantidade máxima deve ser maior que 0.</div>
                }
              }

              @if (ticketForm.touched) {
                @if (ticketForm.errors?.["maxTicketsExceededQuantity"]) {
                  <div class="invalid-feedback">
                    A quantidade máxima por compra não pode ser maior que a quantidade disponível.
                  </div>
                }
                @if (ticketForm.errors?.["maxTicketsLessThanMinTickets"]) {
                  <div class="invalid-feedback">
                    A quantidade máxima por compra não pode ser menor que a quantidade mínima.
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="secondary" (click)="closeModal()">Cancelar</app-button>
  <app-button type="submit" (click)="saveTicket()">Salvar</app-button>
</mat-dialog-actions>
